import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {AdvancedDeliveryModule} from './AdvancedDelivery.module';
import {endProc} from '../../_shared/GWTBridge/invoke/procMain';
import {getNextMaxDialogsZIndex} from '../../_shared/GWTBridge/invoke/genPage';
import {ScreenLocker} from '../Form/components/ScreenLocker';
import {getServerTexts} from './texts';
import {useEventListener} from '../../hooks/useEventListener';
import {keys} from '../../constants/KeyCodes';

export const ADPDialog = forwardRef((props: {session: string}, ref: any) => {
    const [zIndex, setZIndex] = useState(getNextMaxDialogsZIndex());
    const [isScreenLocked, setIsScreenLocked] = useState(false);
    const [textsLoaded, setTextsLoaded] = React.useState(false);

    const updateZIndex = (zIndex: number) => {
        setZIndex(zIndex);
    };

    const getZIndex = (): number => {
        return zIndex;
    };
    useImperativeHandle(
        ref,
        () => {
            return {
                updateZIndex: updateZIndex,
                getZIndex: getZIndex,
                unlockAdpScreen: () => setIsScreenLocked(false)
            };
        },
        [zIndex, getZIndex]
    );
    const handleClose = () => {
        endProc();
    };

    useEffect(() => {
        (async () => {
            await getServerTexts();
            setTextsLoaded(true);
        })();
    }, []);

    useEventListener('keydown', e => {
        if (e.key === keys.ESC) {
            handleClose();
        }
    });

    if (!textsLoaded) {
        return null;
    }

    return (
        <>
            <AdvancedDeliveryModule
                {...props}
                onClose={handleClose}
                zIndex={zIndex}
                setIsScreenLocked={setIsScreenLocked}
            />
            <ScreenLocker
                showLoader={isScreenLocked}
                locked={isScreenLocked}
                zIndex={zIndex}
                canCancel={false}
            />
        </>
    );
});
